/* eslint-disable react-hooks/exhaustive-deps */

import { ReloadOutlined, SettingOutlined } from '@ant-design/icons'
import { Col, Row, Tag, Tooltip } from 'antd'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import IconCameraOnvif from '../../../assets/icons/camera_onvif.svg'
import IconCameraRtsp from '../../../assets/icons/camera_rtsp.svg'
import Info from '../../../assets/icons/info.svg'
import Info11 from '../../../assets/icons/info_11.svg'
import Info12 from '../../../assets/icons/info_12.svg'
import Info3 from '../../../assets/icons/info_3.svg'
import Info5 from '../../../assets/icons/info_5.svg'
import Info6 from '../../../assets/icons/info_6.svg'
import Info7 from '../../../assets/icons/info_7.svg'
import LiveIconOn from '../../../assets/icons/live-streaming-on.svg'
import OffStream from '../../../assets/icons/off_stream.svg'
import PlayIconNoActive from '../../../assets/icons/play-button-no-active.svg'
import PlayIcon from '../../../assets/icons/play-button.svg'
import Thumbnail from '../../../assets/images/thumbnail.jpg'
import * as SERVICE from '../../../constants/service.types'
import { ZOOM_STATE } from '../../../constants/system.keys'
import {
  socketEmitEvent,
} from '../../../redux/actions'

import MilestonePlayerComponent from '../../Player/MilestonePlayer'
import '../index.scss'
import clsx from 'clsx'
import { formatMilestonePlaybackTime } from '../../Playback/ProgressBar/utils'
import { useLatestCameraState } from '../../../hooks/use-latest-camera-state'

const RETRY_PAUSE = 2000
const TRY_LOAD_TIMER_DEFAULT = 10

const pc_config = {
  iceServers: [
    { urls: ["stun:stun.l.google.com:19302"] },
    {
      urls: [
        "turn:stun01.beex.vn:3478?transport=udp",
        "turn:stun01.beex.vn:3478?transport=tcp",
        "turns:stun01.beex.vn:5349?transport=tcp"
      ],
      username: "beex",
      credential: "82zu0TPZFTXp6qau"
    }
  ],
  iceTransportPolicy: "all",
}

const MilestoneVideoStreamComponent = ({
  serial,
  name,
  typeCamera,
  state,
  resolution,
  iconSize,
  isInternal,
  thumbnail,
  zoomState,
  serviceId,
  isViewAll,
  permission,
  isAllowStreaming,
  handleUpdateCamera,
  tabActive,
  onlyShowThumbnail,
  showSetting = true,
  isSelected = false,
  variant = 'camera-page',
  queryPlayback
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    namespace,
    listDeviceContact,
    sessionStreamMilestones,
    updateCandidateMilestoneReturn,
    dataUser,
  } = useSelector((state) => state)

  const [isFullscreen, setIsFullscreen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [onPlay, setOnPlay] = useState(false)
  const [sourceObject, setSourceObject] = useState(null)

  const [streamId, setStreamId] = useState(null)
  const [sessionStreaming, setSessionStreaming] = useState(null)
  const [remoteCandidates, setRemoteCandidates] = useState([])

  const [isLoadReload, setIsLoadReload] = useState(false)
  const [tryLoadTimer, setTryLoadTimer] = useState(TRY_LOAD_TIMER_DEFAULT)
  const [countRetryStream, setCountRetryStream] = useState(1)

  const [zoomStatePlayer, setZoomStatePlayer] = useState(null)
  const [zoomStateDefault, setZoomStateDefault] = useState(null)
  const [checkTransferZoomState, setCheckTransferZoomState] = useState(false)

  const refPeerConnection = useRef(null)
  const restartTimeout = useRef(null)
  const refTryLoad = useRef(null)
  const [playbackTimeNode, setPlaybackTimeNode] = useState({
    playbackTime: '',
    speed: '1.0'
  })
  const latestState = useLatestCameraState({ serial, defaultState: state });

  useEffect(() => {
    if (queryPlayback && queryPlayback?.playbackTime) {
      console.log('🚀 ~ MilestoneVideoStreamComponent ~ queryPlayback:', queryPlayback)
      setSourceObject(null)
      setPlaybackTimeNode({
        playbackTime: queryPlayback?.playbackTime,
        speed: queryPlayback?.speed || '1.0'
      })
      setTimeout(() => {
        setOnPlay(true)
      }, 100);
    }
  }, [queryPlayback]);

  useEffect(() => {
    if (zoomState) {
      setZoomStatePlayer(zoomState)
      setZoomStateDefault(zoomState)
    }
  }, [zoomState])

  useEffect(() => {
    let timeoutClear
    if (
      onPlay &&
      dataUser?.accountConfiguration &&
      JSON.parse(dataUser?.accountConfiguration)?.liveTimeout > 0
    ) {
      const dataTimeout = JSON.parse(
        dataUser?.accountConfiguration
      )?.liveTimeout
      timeoutClear = setTimeout(() => {
        handleStopStream()
        setOnPlay(false)
      }, dataTimeout * 1000)
    }
    return () => {
      if (timeoutClear) clearTimeout(timeoutClear)
    }
  }, [onPlay, dataUser])

  const onError = useCallback(
    (err) => {
      console.error('MilestoneVideoStream Error:', err)

      if (!restartTimeout.current) {
        if (refPeerConnection.current) {
          refPeerConnection.current.close()
          refPeerConnection.current = null
        }

        restartTimeout.current = window.setTimeout(() => {
          restartTimeout.current = null
          console.log('Attempting to restart stream...')
          startSessionStream()
        }, RETRY_PAUSE)

        setRemoteCandidates([])
        setSourceObject(null)
      }
    },
    [serial, namespace, resolution]
  )

  const startSessionStream = useCallback((data) => {
    const requestTime = new Date().getTime()
    const dataBody = {
      serial,
      namespace,
      streamId: requestTime,
      resolution: data?.resolution || resolution,
      includeAudio: !!data?.includeAudio,
      iceServers: [{ urls: ["stun:stun.l.google.com:19302"] }],
    }
    if (playbackTimeNode?.playbackTime) {
      dataBody.playbackTimeNode = playbackTimeNode
    }
    const dataObject = {
      appServiceType: SERVICE.START_SESSION_STREAM_MILESTONE,
      requestId: requestTime,
      body: JSON.stringify(dataBody)
    }
    console.log('Starting session stream:', dataObject.body)
    setStreamId(requestTime)
    setLoading(true)
    return dispatch(socketEmitEvent(dataObject))
  }, [serial, namespace, resolution, dispatch, playbackTimeNode])

  useEffect(() => {
    if (sessionStreamMilestones && streamId) {
      const session = sessionStreamMilestones.find(
        ss => String(ss?.streamId) === String(streamId) &&
          String(ss?.deviceSerial) === String(serial)
      )
      setSessionStreaming(session || null)
    }
  }, [sessionStreamMilestones, streamId, serial])

  const updateAnswerSDP = useCallback((localDescription) => {
    if (!sessionStreaming?.sessionId) return

    const requestTime = new Date().getTime()
    const dataBody = {
      serial,
      namespace,
      streamId,
      sessionId: sessionStreaming.sessionId,
      answerSDP: localDescription,
    }
    const dataObject = {
      appServiceType: SERVICE.UPDATE_ANSWER_SDP_MILESTONE,
      requestId: requestTime,
      body: JSON.stringify(dataBody)
    }
    dispatch(socketEmitEvent(dataObject))
  }, [serial, namespace, streamId, sessionStreaming, dispatch])

  const updateCandidateStream = useCallback((candidate) => {
    if (!sessionStreaming?.sessionId) return

    const requestTime = new Date().getTime()
    const dataBody = {
      serial,
      namespace,
      streamId,
      sessionId: sessionStreaming.sessionId,
      candidateWeb: JSON.stringify(candidate),
    }
    const dataObject = {
      appServiceType: SERVICE.UPDATE_CANDIDATE_WEB_MILESTONE,
      requestId: requestTime,
      body: JSON.stringify(dataBody)
    }
    dispatch(socketEmitEvent(dataObject))
  }, [serial, namespace, streamId, sessionStreaming, dispatch])

  const onTrack = useCallback((event) => {
    if (!event?.streams || event.streams.length === 0) return
    console.log('onTrack - Stream received:', event)
    setSourceObject(event.streams[0])
    setLoading(false)
  }, [])

  const onIceConnectionStateChange = useCallback(() => {
    if (!refPeerConnection.current) return

    const state = refPeerConnection.current.iceConnectionState
    console.log('ICE Connection State:', state)

    if (restartTimeout.current) return

    if (state === 'disconnected' || state === 'failed') {
      console.warn('Peer connection closed/failed, restarting...')
      onError('Peer connection state: ' + state)
    } else if (state === 'connected' || state === 'completed') {
      console.log('Peer connection established successfully')
      setLoading(false)
    }
  }, [onError])

  useEffect(() => {
    if (!sessionStreaming?.offerSDP) return

    console.log('Setting up peer connection with offer SDP')

    if (refPeerConnection.current) {
      console.log('Closing existing peer connection')
      refPeerConnection.current.close()
    }

    refPeerConnection.current = new RTCPeerConnection(pc_config)

    refPeerConnection.current.ontrack = onTrack
    refPeerConnection.current.onicecandidate = (event) => {
      if (event.candidate) {
        updateCandidateStream(event.candidate)
      }
    }
    refPeerConnection.current.oniceconnectionstatechange = onIceConnectionStateChange

    const sdpData = {
      type: 'offer',
      sdp: sessionStreaming.offerSDP,
    }
    const remoteSessionDescription = new RTCSessionDescription(sdpData)

    refPeerConnection.current
      .setRemoteDescription(remoteSessionDescription)
      .then(() => {
        return refPeerConnection.current.createAnswer()
      })
      .then((localDescription) => {
        return refPeerConnection.current.setLocalDescription(localDescription)
          .then(() => {
            updateAnswerSDP(localDescription)
          })
      })
      .catch((error) => {
        console.error('Error setting up peer connection:', error)
        onError(error.toString())
      })

    return () => {
      if (refPeerConnection.current) {
        refPeerConnection.current.close()
        refPeerConnection.current = null
      }
    }
  }, [sessionStreaming?.offerSDP, onTrack, updateCandidateStream, updateAnswerSDP, onIceConnectionStateChange, onError])

  useEffect(() => {
    if (!refPeerConnection.current || !updateCandidateMilestoneReturn) return
    if (!sessionStreaming?.sessionId) return
    if (updateCandidateMilestoneReturn.sessionId !== sessionStreaming.sessionId) return

    const iceState = refPeerConnection.current.iceConnectionState
    if (iceState !== 'new' && iceState !== 'checking') return

    const candidates = updateCandidateMilestoneReturn.candidates
    if (!candidates || candidates.length === 0) return

    candidates.forEach(c => {
      if (!remoteCandidates.includes(c)) {
        setRemoteCandidates(prev => [...prev, c])
        refPeerConnection.current
          .addIceCandidate(JSON.parse(c))
          .catch(err => console.error('Error adding ICE candidate:', err))
      }
    })
  }, [updateCandidateMilestoneReturn, sessionStreaming, remoteCandidates])

  useEffect(() => {
    if (onPlay && !sourceObject) {
      startSessionStream()
    }
  }, [onPlay, startSessionStream])

  const handleTryLoad = useCallback(() => {
    console.log('🚀 ~ MilestoneVideoStreamComponent ~ isLoadReload:', isLoadReload)
    if (isLoadReload) return

    console.log('Manual reload triggered')
    setIsLoadReload(true)
    setTryLoadTimer(TRY_LOAD_TIMER_DEFAULT)

    refTryLoad.current = setInterval(() => {
      setTryLoadTimer((timer) => timer - 1)
    }, 1000)

    startSessionStream()
  }, [isLoadReload, startSessionStream])

  useEffect(() => {
    if (tryLoadTimer === 0) {
      setIsLoadReload(false)
      if (refTryLoad.current) {
        clearInterval(refTryLoad.current)
        refTryLoad.current = null
      }
      setTryLoadTimer(TRY_LOAD_TIMER_DEFAULT)
    }
  }, [tryLoadTimer])

  const restartCallBack = useCallback((dataObject) => {
    console.log('Restart callback triggered with:', dataObject)

    handleStopStream()

    setTimeout(() => {
      startSessionStream({
        resolution: dataObject?.resolution,
        includeAudio: dataObject?.includeAudio,
      })
    }, 1000)
  }, [startSessionStream])

  const restartLoadingCallBack = useCallback((dataObject) => {
    console.log('Restart loading callback triggered')

    handleStopStream()

    setTimeout(() => {
      startSessionStream(dataObject)
    }, 1000)
  }, [startSessionStream])

  const restartQualityCallBack = useCallback((dataObject) => {
    console.log('Restart quality callback triggered')

    handleStopStream()

    setTimeout(() => {
      startSessionStream(dataObject)
    }, 500)
  }, [startSessionStream])

  const handleStopStream = useCallback(() => {
    console.log('Stopping stream')

    if (restartTimeout.current) {
      clearTimeout(restartTimeout.current)
      restartTimeout.current = null
    }

    if (refPeerConnection.current) {
      refPeerConnection.current.close()
      refPeerConnection.current = null
    }

    if (refTryLoad.current) {
      clearInterval(refTryLoad.current)
      refTryLoad.current = null
    }

    setSourceObject(null)
    setLoading(false)
    setSessionStreaming(null)
    setRemoteCandidates([])
    setStreamId(null)
  }, [])

  useEffect(() => {
    return () => {
      handleStopStream()
    }
  }, [handleStopStream])

  const onChangeHover = useCallback(() => {
    if (!serial || !namespace) return

    const dataBody = {
      namespace,
      serial,
    }
    const dataObj = {
      appServiceType: SERVICE.GET_DEVICE_CONTACT_INFO,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    }
    dispatch(socketEmitEvent(dataObj))
  }, [serial, namespace, dispatch])

  const onRotateCamera = useCallback((navigator) => {
    if (!sessionStreaming?.serial) return

    const dataBody = {
      navigator,
      namespace,
      serial: sessionStreaming.serial,
    }
    const dataObj = {
      appServiceType: SERVICE.ROTATE_VIEW_CAMERA,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    }
    return dispatch(socketEmitEvent(dataObj))
  }, [dispatch, namespace, sessionStreaming])

  const onZoomCamera = useCallback((zoom) => {
    if (!sessionStreaming?.serial) return

    const dataBody = {
      zoom,
      namespace,
      serial: sessionStreaming.serial,
    }
    const dataObj = {
      appServiceType: SERVICE.ZOOM_VIEW_CAMERA,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    }
    return dispatch(socketEmitEvent(dataObj))
  }, [dispatch, namespace, sessionStreaming])

  return (
    <div
      className={clsx('view-stream-component-wrapper', {
        'is-selected': isSelected,
        'is-camera-page': variant === 'camera-page',
      })}
      style={{ background: '#fff', width: 'inherit' }}
      data-serial={serial}
    >
      <div className="view-stream-component" style={{ height: '100%' }}>
        {!onlyShowThumbnail && tabActive === 'live' && (
          <>
            {latestState === 1 ? (
              !!!sourceObject && (
                <div className="icon-live-stream">
                  <img
                    width={iconSize || 26}
                    height={iconSize || 26}
                    className="icon"
                    alt="live-stream-icon"
                    src={LiveIconOn}
                  />
                </div>
              )
            ) : (
              <div className="icon-live-stream">
                <img
                  width={iconSize || 26}
                  height={iconSize || 26}
                  className="icon"
                  alt="live-stream-icon"
                  src={OffStream}
                />
              </div>
            )}

            {!!!sourceObject && (
              <div className="icon-type-stream">
                <img
                  width={iconSize || 26}
                  height={iconSize || 26}
                  className="icon"
                  alt="camera-type-icon"
                  src={typeCamera === 'onvif' ? IconCameraOnvif : IconCameraRtsp}
                />
              </div>
            )}

            {!!!sourceObject && (
              <Tooltip
                placement="left"
                mouseEnterDelay={0.5}
                title={
                  <Row>
                    <Col span={24}>
                      <Row
                        style={{
                          borderBottom: '1px solid #303030',
                          paddingBottom: '10px',
                        }}
                      >
                        <Col span={18} style={{ fontWeight: 'bold', fontSize: '13px' }}>
                          {listDeviceContact?.name || ''}
                        </Col>
                        <Col span={6}>
                          {listDeviceContact?.state === 1 ? (
                            <Tag color="rgb(14, 147, 71)">Online</Tag>
                          ) : (
                            <Tag color="rgb(79, 77, 77)">Offline</Tag>
                          )}
                        </Col>
                      </Row>
                    </Col>

                    {listDeviceContact?.note && (
                      <Col span={24} style={{ marginTop: '10px', fontSize: '13px' }}>
                        <img
                          className="info-icon-stream"
                          alt="info-icon"
                          style={{ marginTop: '-2px' }}
                          src={Info3}
                        />
                        {listDeviceContact.note}
                      </Col>
                    )}

                    {latestState === 0 && (
                      <Col span={24}>
                        <Row>
                          {listDeviceContact?.errorTime && (
                            <Col span={24} style={{ marginTop: '5px', fontSize: '13px' }}>
                              <img
                                className="info-icon-stream"
                                alt="error-time-icon"
                                style={{ marginTop: '-2px' }}
                                src={Info11}
                              />
                              {t('Time')}:{' '}
                              <span style={{ color: 'rgb(245, 47, 57)' }}>
                                {listDeviceContact.errorTime}
                              </span>
                            </Col>
                          )}
                          {listDeviceContact?.errorMessage && (
                            <Col span={24} style={{ marginTop: '5px', fontSize: '13px' }}>
                              <img
                                className="info-icon-stream"
                                alt="error-msg-icon"
                                style={{ marginTop: '-2px' }}
                                src={Info12}
                              />
                              {t('Reason')}:{' '}
                              <span style={{ color: 'rgb(245, 47, 57)' }}>
                                {listDeviceContact.errorMessage}
                              </span>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    )}

                    <Col span={24} style={{ marginTop: '10px', fontSize: '13px' }}>
                      <img
                        className="info-icon-stream"
                        alt="person-icon"
                        style={{ marginTop: '-2px' }}
                        src={Info5}
                      />
                      <span style={{ color: '#1757B7' }}>
                        {t('PERSON IN CHARGE')}
                      </span>
                    </Col>

                    {listDeviceContact?.assigners?.length > 0 &&
                      listDeviceContact.assigners.map((item, index) => (
                        <Col span={24} key={index}>
                          <Row>
                            {item.fullName && (
                              <Col span={24} style={{ marginTop: '5px', fontSize: '13px' }}>
                                <img
                                  className="info-icon-stream"
                                  alt="name-icon"
                                  style={{ marginTop: '-2px' }}
                                  src={Info6}
                                />
                                {t('Họ tên')}: {item.fullName}
                              </Col>
                            )}
                            {item.phoneNumber && (
                              <Col span={24} style={{ marginTop: '5px', fontSize: '13px' }}>
                                <img
                                  className="info-icon-stream"
                                  alt="phone-icon"
                                  style={{ marginTop: '-2px' }}
                                  src={Info7}
                                />
                                {t('Phone number')}: {item.phoneNumber}
                              </Col>
                            )}
                          </Row>
                        </Col>
                      ))}
                  </Row>
                }
              >
                <div className="icon-info-stream" onMouseOver={onChangeHover}>
                  <img
                    width={iconSize || 26}
                    height={iconSize || 26}
                    className="icon"
                    alt="info-icon"
                    src={Info}
                  />
                </div>
              </Tooltip>
            )}

            {latestState === 0 &&
              permission?.split('_')?.includes('live') && (
                <>
                  <div
                    onClick={handleTryLoad}
                    className="preload-spinner reconnect"
                  >
                    <ReloadOutlined
                      // className={isAllowStreaming === 0 ? 'no-active' : ''}
                      style={{ fontSize: 48 }}
                      spin={isLoadReload}
                    />
                  </div>
                  {isAllowStreaming === 0 && tabActive === 'live' && (
                    <div className="text-no-active">
                      <Tag color="#f50">{t('Not active')}</Tag>
                    </div>
                  )}
                </>
              )}
          </>
        )}

        {onPlay ? (
          <MilestonePlayerComponent
            tabActive={tabActive}
            key={serial}
            name={name}
            onvif={typeCamera === 'onvif'}
            onRotate={onRotateCamera}
            onZoom={onZoomCamera}
            resolution={resolution}
            zoomStateProps={zoomStateDefault ?? zoomState}
            isFullscreenProps={isFullscreen}
            restartCallBack={restartCallBack}
            restartLoadingCallBack={restartLoadingCallBack}
            fullScreenCallBack={(isFull) => setIsFullscreen(isFull)}
            type="streaming"
            loading={loading}
            sourceObject={sourceObject}
            poster={thumbnail?.match(/http/g) ? thumbnail : Thumbnail}
            setOnPlay={setOnPlay}
            serial={serial}
            checkTransferZoomState={checkTransferZoomState}
            zoomStatePlayer={zoomStatePlayer}
            setZoomStatePlayer={setZoomStatePlayer}
            restartQualityCallBack={restartQualityCallBack}
          />
        ) : (
          <div className="video-wrapper thumbnail">
            {latestState === 1 && permission?.split('_')?.includes('live') && tabActive === 'live' && (
              <>
                <img
                  alt="play-icon"
                  onClick={() => {
                    // if (isAllowStreaming !== 0) {
                    setOnPlay(true)
                    // }
                  }}
                  // src={isAllowStreaming === 0 ? PlayIconNoActive : PlayIcon}
                  src={PlayIcon}
                />
                {isAllowStreaming === 0 && tabActive === 'live' && (
                  <div className="text-no-active">
                    <Tag color="#f50">{t('Not active')}</Tag>
                  </div>
                )}
              </>
            )}
            <video
              poster={thumbnail?.match(/http/g) ? thumbnail : Thumbnail}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default MilestoneVideoStreamComponent